import {
  computeItemIdentifier,
  Configuration,
} from '@o3r/core';
import {
  COMPONENTS_CONFIGURATION_NAME,
} from '../../../configuration/index';

export interface ExitFlowConfig extends Configuration {
  /**
   * Will redirect to identification page or on the link provided in localization
   */
  redirectOnIdentification: boolean;

  /**
   * Define if the component is a link instead of a button
   */
  isLink: boolean;
}

export const EXIT_FLOW_DEFAULT_CONFIG: ExitFlowConfig = {
  redirectOnIdentification: true,
  isLink: false
};

export const EXIT_FLOW_CONFIG_ID = computeItemIdentifier('ExitFlowConfig', COMPONENTS_CONFIGURATION_NAME);
